"use client";

interface InspectionTypeCardProps {
    selected: boolean;
    onClick: () => void;
    title: string;
    description: string;
    price: number;
}

const InspectionTypeCard = ({ selected, onClick, title, description, price }: InspectionTypeCardProps) => (
    <button
        type="button"
        onClick={onClick}
        className={[
            "flex flex-col items-start rounded-2xl border-2 p-5 text-start transition-all duration-300 ease-in-out",
            selected
                ? "border-primary bg-primary/5 "
                : " border-gray-200 bg-white  hover:border-gray-300 ",
        ].join(" ")}
    >
        <div className="mb-2 flex w-full items-center justify-between">
            <span className="font-urbanist text-base font-semibold text-black">{title}</span>

            {/* Animated radio indicator */}
            <div
                className={[
                    "flex h-5 w-5 items-center justify-center rounded-full border-2 transition-all duration-300",
                    selected ? "border-primary bg-primary" : "border-gray-300 bg-white",
                ].join(" ")}
            >
                <div
                    className={[
                        "rounded-full bg-white transition-all duration-300",
                        selected ? "h-2 w-2 scale-100 opacity-100" : "h-0 w-0 scale-0 opacity-0",
                    ].join(" ")}
                />
            </div>
        </div>

        <p className="inter text-sm text-secondary-foreground">{description}</p>

        <span
            className={[
                "mt-3 font-urbanist text-xl font-semibold transition-colors duration-300",
                selected ? "text-primary" : "text-secondary-foreground",
            ].join(" ")}
        >
            AED {price} (+VAT)
        </span>
    </button>
);

export default InspectionTypeCard;